module.exports = __webpack_public_path__ + "img/calendar-picker-icon.57634228.svg";